import $api from '../../api/index';
import { normalizeRelations, resolveRelations } from '../helpers';

const getDefaultState = () => ({
  allIds: [],
  byId: {}
});

const state = getDefaultState();

const getters = {
  // Return a single article with the given id.
  find: (state, _, __, rootGetters) => id =>
    // Swap ID references with the resolved module objects.
    resolveRelations(state.byId[id], ['modules'], rootGetters, {
      inCart: true
    })

  // Return a list of assignments in the order of `allIds`.
  // NOT NEEDED FOR assignments
  // list: (state, getters) => state.allIds.map(id => getters.find(id))
};

const actions = {
  async getAssignments({ commit, dispatch, state, rootState, getters }, payload) {
    const { assignmentId } = payload;
    payload.location = payload.location || 'pass';

    if (state.allIds.includes(assignmentId)) return getters.find(assignmentId);
    // Go ahead and fetch data
    await $api.assignments
      .getAssignments(payload, rootState)
      .then(({ data }) => {
        // Create the assignment object
        const assignment = {
          id: assignmentId,
          modules: data.modules
        };

        // Add the assignment to the store with the modules normalized
        commit('add', normalizeRelations(assignment, ['modules']));

        // Add each module (module store will normalize its own data)
        assignment.modules.forEach(module => {
          dispatch('cartModules/addModule', module, { root: true });
        });
      });
  },
  resetAssignments({ commit }) {
    commit('reset');
  }
};

const mutations = {
  add: (state, item) => {
    state.byId[item.id] = item;
    if (state.allIds.includes(item.id)) return;
    state.allIds.push(item.id);
  },
  reset: state => Object.assign(state, getDefaultState())
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
};
